exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sweet-modal-overlay{-webkit-perspective:initial}.modal-containuous-container .sweet-modal.is-alert{width:800px}.modal-containuous-container .sweet-modal.is-alert .sweet-content{padding:42px}", ""]);

// exports
